export const CustomTaskAPI = {
  list: openapiStrictFetch({
    url: 'v2/tasks/custom',
  }),
  fund: openapiStrictFetch({
    url: 'v2/tasks/custom/{taskId}',
  }),
  create: openapiStrictFetch({
    url: 'v2/tasks/custom',
    method: HTTPMethod.POST,
  }),
  update: openapiStrictFetch({
    url: 'v2/tasks/custom/{taskId}',
    method: HTTPMethod.PUT,
  }),
  delete: openapiStrictFetch({
    url: 'v2/tasks/custom/{taskId}',
    method: HTTPMethod.DELETE,
  }),
  toggleApply: openapiStrictFetch({
    url: 'v2/tasks/custom/{taskId}/apply',
    method: HTTPMethod.PUT,
  }),
};
